import * as React from "react";

interface FormData {
  first_name: string;
  last_name: string;
  email_id: string;
  mobile_number: string;
  city: string;
  province: string;
  country: string;
}

interface FormErrors {
  first_name?: string;
  last_name?: string;
  email_id?: string;
  mobile_number?: string;
  city?: string;
  province?: string;
  country?: string;
}

interface Props {
  formData: FormData;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errors: FormErrors;
}

const AddCustomerForm: React.FC<Props> = ({ formData, onInputChange, errors }) => {
  return (
    <div className="w-full mx-auto">
      <form className="flex flex-col gap-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 w-full gap-2">
          {/* First Name */}
          <div className="flex flex-col">
            <label
              htmlFor="first_name"
              className="xs:text-[9px] sm:text-[13px] md:text-[13px] lg:text-[15px] xl:text-[15px] text-gray-400 font-semibold"
            >
              First Name
            </label>
            <input
              type="text"
              id="first_name"
              name="first_name"
              value={formData.first_name}
              className={`w-full mt-1 px-3 py-2 rounded-lg outline-none text-black bg-transparent duration-200 border ${
                errors.first_name ? "border-red-500" : "border-gray-300"
              } focus:ring-indigo-500 focus:border-indigo-500 xs:text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px] xl:text-[15px]`}
              onChange={onInputChange}
            />
            {errors.first_name && (
              <span className="text-red-500 text-xs mt-1">
                {errors.first_name}
              </span>
            )}
          </div>

          {/* Last Name */}
          <div className="flex flex-col">
            <label
              htmlFor="last_name"
              className="xs:text-[9px] sm:text-[13px] md:text-[13px] lg:text-[15px] xl:text-[15px] text-gray-400 font-semibold"
            >
              Last Name
            </label>
            <input
              type="text"
              id="last_name"
              name="last_name"
              value={formData.last_name}
              onChange={onInputChange}
              className={`w-full mt-1 px-3 py-2 rounded-lg outline-none text-black bg-transparent duration-200 border ${
                errors.last_name ? "border-red-500" : "border-gray-300"
              } focus:ring-indigo-500 focus:border-indigo-500 xs:text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px] xl:text-[15px]`}
            />
            {errors.last_name && (
              <span className="text-red-500 text-xs mt-1">
                {errors.last_name}
              </span>
            )}
          </div>

          {/* Email */}
          <div className="flex flex-col">
            <label
              htmlFor="email_id"
              className="xs:text-[9px] sm:text-[13px] md:text-[13px] lg:text-[15px] xl:text-[15px] text-gray-400 font-semibold"
            >
              Email Address
            </label>
            <input
              type="email"
              id="email_id"
              name="email_id"
              value={formData.email_id}
              onChange={onInputChange}
              className={`w-full mt-1 px-3 py-2 rounded-lg outline-none text-black bg-transparent duration-200 border ${
                errors.email_id ? "border-red-500" : "border-gray-300"
              } focus:ring-indigo-500 focus:border-indigo-500 xs:text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px] xl:text-[15px]`}
            />
            {errors.email_id && (
              <span className="text-red-500 text-xs mt-1">
                {errors.email_id}
              </span>
            )}
          </div>

          {/* Mobile Number */}
          <div className="flex flex-col">
            <label
              htmlFor="mobile_number"
              className="xs:text-[9px] sm:text-[13px] md:text-[13px] lg:text-[15px] xl:text-[15px] text-gray-400 font-semibold"
            >
              Mobile Number
            </label>
            <input
              type="tel"
              id="mobile_number"
              name="mobile_number"
              value={formData.mobile_number}
              onChange={onInputChange}
              className={`w-full mt-1 px-3 py-2 rounded-lg outline-none text-black bg-transparent duration-200 border ${
                errors.mobile_number ? "border-red-500" : "border-gray-300"
              } xs:text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px] xl:text-[15px]`}
            />
            {errors.mobile_number && (
              <span className="text-red-500 text-xs mt-1">
                {errors.mobile_number}
              </span>
            )}
          </div>

          {/* City */}
          <div className="flex flex-col">
            <label
              htmlFor="city_input"
              className="xs:text-[9px] sm:text-[13px] md:text-[13px] lg:text-[15px] xl:text-[15px] text-gray-400 font-semibold"
            >
              City
            </label>
            <input
              type="text"
              id="city_input"
              name="city"
              value={formData.city}
              onChange={onInputChange}
              className={`w-full mt-1 px-3 py-2 rounded-lg outline-none text-black bg-transparent duration-200 border ${
                errors.city ? "border-red-500" : "border-gray-300"
              } xs:text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px] xl:text-[15px]`}
            />
            {errors.city && (
              <span className="text-red-500 text-xs mt-1">{errors.city}</span>
            )}
          </div>

          {/* Province */}
          <div className="flex flex-col">
            <label
              htmlFor="province_input"
              className="xs:text-[9px] sm:text-[13px] md:text-[13px] lg:text-[15px] xl:text-[15px] text-gray-400 font-semibold"
            >
              Province
            </label>
            <input
              type="text"
              id="province_input"
              name="province"
              value={formData.province}
              onChange={onInputChange}
              className={`w-full mt-1 px-3 py-2 rounded-lg outline-none text-black bg-transparent duration-200 border ${
                errors.province ? "border-red-500" : "border-gray-300"
              } xs:text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px] xl:text-[15px]`}
            />
            {errors.province && (
              <span className="text-red-500 text-xs mt-1">
                {errors.province}
              </span>
            )}
          </div>

          {/* Country */}
          <div className="flex flex-col">
            <label
              htmlFor="country_input"
              className="xs:text-[9px] sm:text-[13px] md:text-[13px] lg:text-[15px] xl:text-[15px] text-gray-400 font-semibold"
            >
              Country
            </label>
            <input
              type="text"
              id="country_input"
              name="country"
              value={formData.country}
              onChange={onInputChange}
              className={`w-full mt-1 px-3 py-2 rounded-lg outline-none text-black bg-transparent duration-200 border ${
                errors.country ? "border-red-500" : "border-gray-300"
              } xs:text-[9px] sm:text-[11px] md:text-[13px] lg:text-[15px] xl:text-[15px]`}
            />
            {errors.country && (
              <span className="text-red-500 text-xs mt-1">
                {errors.country}
              </span>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddCustomerForm;